import Axios from "axios";
import {handleAjaxSuccess, swalConfirm} from "../../helpers/swalHelper";
import {createGrid} from "../../helpers/grids/grids";
import createElement from "../../helpers/createElement";
import {createCellRenderer} from "../../helpers/grids/helpers";
import {ServerModalV3} from "../../helpers/modals/ClassBased/ServerModalV3";
import {initFlatPickerInput} from "../../helpers/inputs/flatPicker/flatPicker";
import {initTomSelectInput} from "../../helpers/inputs/tom-select/tom-select";
import {loading, stopLoading} from "../../helpers/loading";
import handleAjaxError from "../../helpers/handleAjaxError";

function initCheckinsHistory() {
	// Init grid
	const grid = createGrid(
		".history-grid",
		{
			columnDefs: [
				{
					field: "created_at",
					headerName: "Checkin Time",
					width: 200,
					sortable: true,
					sort: "desc",
				},
				{
					field: "fullName",
					headerName: "Name",
					sortable: true,
				},
				{
					field: "checkedInBy",
					headerName: "Checked In By",
					sortable: false,
				},
				{
					field: "editModal",
					headerName: "",
					minWidth: 220,
					maxWidth: 240,
					cellRenderer: createCellRenderer((params) => {
						// noinspection JSUnresolvedVariable ${params.data.edit_url}
						const buttons = createElement(`
                            <div class="buttons">
                                <button class="btn btn-primary btn-sm edit-modal-button">
                                    <i class="fa-solid fa-circle-info"></i>
                                    Edit Time
								</button>
								 <button class="btn btn-danger btn-sm delete-button">
                                    <i class="fa-solid fa-trash"></i>
                                    Delete
								</button>
                            </div>`);

						const editModal =
							buttons.querySelector(".edit-modal-button");

						// noinspection JSUnresolvedReference
						editModal.onclick = () =>
							renderModal(params.data.editModal);

						const deleteButton = buttons.querySelector('.delete-button');

						if (deleteButton) {
							deleteButton.addEventListener("click", () => deleteCheckin(params.data))
						}

						return buttons;
					}),
				},
			],
			paginationPageSize: 20,
			_rowName: "Users",
			rowClass: "cursor-pointer",
		},
		window["routes/admin.checkins.history-grid"]
	);

	const addCheckinButton = document.querySelector(".add-checkin-button");
	addCheckinButton.addEventListener("click", () => {
		const info = {
			checkinModal: window["routes/admin.checkins.history.modal"],
			route: window["routes/admin.checkins.history.store"],
		};

		renderModal(info);
	});

	/** Methods */

	function renderModal(info) {
		const date = info.data ?? new Date();
		const checkinModal = info.checkinModal;
		const route = info.route;

		new ServerModalV3(checkinModal, {
			init(modal) {
				const checkinPicker = modal.modalContainer.querySelector(
					".checkin-time-picker"
				);

				const person = modal.modalContainer.querySelector(
					'select[name="person"]'
				);

				if (person) {
					initTomSelectInput(person);
				}

				// Convert to the format Flatpickr needs
				let formattedDate = new Date(date); // Parse the date string into a Date object
				// // Set date values using Flatpickr's setDate method
				initFlatPickerInput(checkinPicker, {
					defaultDate: formattedDate, // Use formatted date here
					enableTime: true,
					time_24hr: false, // Optional, keep false if you want 12-hour format
					static: true,
					onOpen: () => {
						setTimeout(() => {
							// Scroll modal to fully display calendar pickert
							modal.modalContainer.querySelector('.modal-body').scrollTop = 1000;
						}, 128)
					}
				});

				modal.modalContainer
					.querySelector(".submit-modal-button")
					.addEventListener("click", () => {
						loading();

						// Send Axios POST request to store the event
						Axios.post(route, {
							checkin: modal.modalContainer.querySelector("#checkin")?.value,
							person: modal.modalContainer.querySelector("#person")?.value,
						})
							.then(function (response) {
								handleAjaxSuccess(response, () => {
									modal.hide()
									grid._silentRefresh();
								});

							})
							.catch(function (error) {
								handleAjaxError(error, modal.modalContainer);
							})
							.finally(stopLoading);
					});
			},
		});
	}

	function deleteCheckin(user) {
		swalConfirm({
			title: 'Are you sure you want to remove this checkin?'
		}).then(response => {
			if (response.isConfirmed) {
				loading();

				// noinspection JSUnresolvedVariable
				Axios.post(user.deleteRoute)
					.then(response => {
						handleAjaxSuccess(response, () => {
							grid._silentRefresh();
						})
					})
					.catch(handleAjaxError)
					.finally(stopLoading);
			}
		})

	}
}

export {initCheckinsHistory};
